
import {
getGoodDetail,
viewCartShop,
getNotifyByPageType,
getRecommendGoodsList,
addCart,
discountAppointment,
getAppointmentNum,
validateDiscountPromotion,
checkIsNew,
getGroupList,
wechatShare,
rateList
} from "@/api/goodDetails"
import {
findEnterpriseWeChat
} from "@/api/index.js"
import {
chkLogin
} from "@/api/login"
import {
getCookie
} from "@/utils/auth.js";
import {
setCookie
} from "@/utils/cookie"
import Swiper from "swiper/swiper-bundle.min.js";
import FloatImgBtn from "@/components/FloatImgBtn.vue"; 
import RateItem from "@/components/goodsDetailRateItem.vue"; 

import {
List,
PullRefresh,
Sticky,
Overlay,
Loading
} from "vant";
import Alert from 'vux/src/components/alert/index.vue'


import NormalGoods from "@/components/goodDetail/normalGoods.vue"; 
import SeckillGood from "@/components/goodDetail/seckillGood.vue"; 
import DepositGood from "@/components/goodDetail/depositGood.vue"; 
import GroupBuyGood from "@/components/goodDetail/groupBuyGood.vue"; 
import AppointGood from "@/components/goodDetail/appointGood.vue"; 
import FooterBtns from "@/components/goodDetail/footerBtns.vue"; 
import SpecsLayer from "@/components/goodDetail/specsLayer.vue"; 
export default {
data() {
return {
staticDomain: "https://misc.reflower.com.cn/",
imgDomian: "https://img.reflower.com.cn/", //图片地址
gid: "",
uid: "", //用户id
spuId: null,
classification:"",
headerImgs: [], //头部滚动图
goodInfo: {}, //商品详情
goods: {}, //商品的goods
skus: [],
skus0: {},
dtimes: [], //可选收货时间
extraList: [], //换购
giftList: [], //赠品
deliveryTime: "", //发货时间
insertBanner: {},
description: null, //商品详情
cartNum: 0, //购物车数量
showPulicNotice: false, //是否关注公众号
tipImgSrc: "",
redirectUrl: "",
showProductDetail: false, //选择商品规格弹窗
sendNumber: 1, //配送周期
introduceText: "", //周期描述
countDownDay: '00',
countDownHour: '00',
countDownMinute: '00',
countDownSecond: '00',
ladderPrices: [], //订阅时间
showCal: false, //日历打开状态
isPresell: 0, //预售商品
presellDate: "", //预售时间
excludeCycleTime: {}, //eskuId 和屏蔽周期时间
showMoreTime: false, //显示更多时间

s_skuId: null, //当前选中的skuid
s_skuLadderPriceId: null, //当前选中的PriceId
s_sendNumber: null, //当前选中的sendNumber
s_number: null, //当前选中的buyNumber
s_getFlowerDate: null, //收货时间
s_getDateType: null, //商品类型
isAuto: null, //自动续订
recommendGoodsList: [], //猜你喜欢
gbpId: null, //团购活动id
type: null, //订单类型
cartFlag: 0, //是否加入购物车
skuLadderPrices: null, //当前sku
isGift: false, //是否送礼
appointmentNum: "", //已预约人数
isOnGoing: false,
haveAppointment: false,
buyLimit: null,
isAppointment: false,
isPreview: false,
greenFirst: "", //日历时间
sdate: 0, //倒计时
minLadderPrice: null, //最低价格的sku
cIsNew: -1, //用户状态 0 老用户  1 新用户  2未送花瓶的新用户
weChat: false, //是否微信环境

showProductImg: false, //显示商品图片
detailImgSrc: "/images/product/productdetail@3x.png", //商品详情默认图

groupList: [], //参团列表
jionGroup: false, //是否 去参团
saleableTime2Extra: "", //换购时间
saleableTime2ExtraExist: false,
saleableTime2Gift: "", //赠品时间
saleableTime2GiftExist: false,
showShare: false, //显示分享
showQrCode: false, //是否显示二维码
headPrice: false, //团长价
startDate: 0, //预约活动开始时间
nowDate: 0, //服务器当前时间
topSpace: 0, //蒙层禁止滚动
showLoading: true, //页面加载loading
giftGoodsImg: "", //赠品券图片
cids: {
9: "包月鲜花",
10: "包月鲜花",
11: "鲜花超市",
12: "鲜花超市",
13: "绿植",
14: "绿植",
15: "礼品鲜花",
16: "礼品鲜花",
17: "花器周边",
18: "花器周边",
19: "节日限定",
20: "节日限定",
21: "活动配置",
22: "活动配置",
23: "其他",
24: "其他",
}, //转化cid商品类目
single_goods_activity_id: "",
single_goods_activity_name: "",
activity_type: "",
buy_way:"",
manystockBalance:false,//是否售罄
showWeChat:false,//是否加微信好友
showBottomWeChat:false,//底部显示是否加好友
muted:true,//静音
isIos:"",//是否ios
autoplay:false,//自动播放
controls:false,//显示操作栏
showPlayBtn:true,//显示播放按钮
newSwiper: {}, //swiper 实例化
rateItemList: [],//评分列表
};
},
beforeRouteLeave(to, from, next) {
var bodyNode = document.body
bodyNode.style.position = ''
bodyNode.style.top = ''
window.scrollTo(0, this.topSpace) 
next()
},

components: {
Alert,
NormalGoods,
SeckillGood,
DepositGood,
GroupBuyGood,
AppointGood,
FooterBtns,
SpecsLayer,
[Overlay.name]: Overlay,
[Loading.name]: Loading,
FloatImgBtn,
RateItem
},

computed: {},

created() {
this.getCurrentEnvironment(); 
let gid = this.getQueryString("gid"); 
this.gid = this.getQueryString("gid");
this.getGoodDetailFun(gid); 
this.getNotifyByPageTypeFun(); 
this.getRecommendGoodsListFun(); 
this.checkIsNewFun(); 
this.uid = getCookie("hdu");
this.setCookieFun();

this.findEnterpriseWeChatFun();

this.getRateList(gid)

},

mounted() {

this.isIos = this.judgeClient();
},

methods: {
setCookieFun: function() {
var urlstr = window.location.href;
var source = this.getQueryString("utm_source");
this.utm_source = source;

let first_utm_source = localStorage.getItem("first_utm_source")
if(first_utm_source == "" || first_utm_source == null || first_utm_source == "undefined"){
localStorage.setItem("first_utm_source",source)
}


var content = this.getQueryString("utm_content");


if (source && source != "null") {
setCookie('utm_source', source)
}
if (content && content != "null") {
setCookie('utm_content', content)
}
},
splitFun: function(str, sign, num) {
if (str != undefined) {
str = str.toString();
let arr = str.split(sign);
if (arr.length > num) {
return arr[num];
} else {
return "00";
}
}
return "";
},
strLengthFun: function(str) {
if (str != undefined) {
let num = str.length;
return num;
}
return 0;
},
getNum: function(firstNum, secondNum) {
if (firstNum != undefined && secondNum != undefined) {
let num = firstNum - secondNum;
return num;
}
return 0;
},
getTotalPrice: function(price, num) {
var total = 1;
if (price != null && price != "" && num != null && num != "") {
total = price * num;
}
return ((total.toString()).indexOf(".") > 0) ? total.toFixed(2) : total;
},
swiperobj(autoplay) {
this.newSwiper = new Swiper(".swiper", {
pagination: {
el: ".swiper-pagination",
},
loop: true,
autoplay: {
delay: 3000,
disableOnInteraction: true,

},
observer: true,
lazyLoading: true,
});





},

getGoodDetailFun(gid) {
let that = this;
getGoodDetail(gid).then(res => {
console.log('res------', res)

that.showLoading = false
if (res.code == 1) {
that.spuId = res.data.g.goods.gid; 
that.classification = res.data.g.goods.classification;

that.goodInfo = res.data.g; 
that.goods = res.data.g.goods; 
that.skus = res.data.g.goods.skus;
that.skus0 = res.data.g.goods.skus[0];
that.deliveryTime = res.data.deliveryTime; 
that.insertBanner = res.data.insertBanner; 
that.description = res.data.g.goods.goodsExt.description.replace(/data-original/g, "data-src"); 
that.dtimes = res.data.dtimes; 
that.extraList = JSON.parse(res.data.g.extraList); 
that.excludeCycleTime = JSON.parse(res.data.excludeCycleTime); 
that.type = res.data.g.type; 
that.isAppointment = res.data.g.isAppointment; 
that.nowDate = res.data.nowDate;
if(res.data.giftGoodsImg){
that.giftGoodsImg = res.data.giftGoodsImg;
}
if (res.data.saleableTime2ExtraExist) {
that.saleableTime2Extra = JSON.parse(res.data.saleableTime2Extra); 
that.saleableTime2ExtraExist = res.data.saleableTime2ExtraExist;
}

if (res.data.saleableTime2GiftExist) {
that.saleableTime2Gift = JSON.parse(res.data.saleableTime2Gift); 
that.saleableTime2GiftExist = res.data.saleableTime2GiftExist;
}



if(res.data.g.goods.goodsExt.moreAddr){
localStorage.setItem("moreAddrDesc", res.data.g.goods.goodsExt.moreAddrDesc);
}


let newHearderImg = [];
for(let item in res.data.g.goods.videos){
let obj = res.data.g.goods.videos[item];
obj.type = "video";
if(item == 0){
obj.autoplay = true;
}else{
obj.autoplay = false;
}
newHearderImg.push(obj)
}
for(let item in res.data.g.goods.imgs){
let obj = res.data.g.goods.imgs[item];
obj.type = "img";
newHearderImg.push(obj)
}
that.headerImgs = newHearderImg;


if(res.data.g.goods.videos != null){
if(res.data.g.goods.videos.length > 0){
that.swiperobj(false);

}else{
let autoplay = {
delay: 3000,
disableOnInteraction: false,
}
that.swiperobj(autoplay);
}
}else{
let autoplay = {
delay: 3000,
disableOnInteraction: false,
}
that.swiperobj(autoplay);
}



console.log("res.data.g.goods.type--------", res.data.g.type)

document.title = res.data.g.goods.title; 


if (this.goods.isCycle) {

that.minLadderPrice = that.getSkuMinPrice(this.goodInfo.ladderPrices);



that.s_skuId = that.minLadderPrice.skuId;
that.s_skuLadderPriceId = that.minLadderPrice.id;
that.s_sendNumber = that.minLadderPrice.sendNumber;
that.s_number = that.minLadderPrice.buyNumber;

if (that.weChat == false && (this.isGift != true || this.goodInfo.displayType == 102 || this.goodInfo.displayType == 103 )) {

}else{
that.isAuto = that.minLadderPrice.isAutoRenew ? 1 : 0;
}


that.oldSkuTotalPrice = that.minLadderPrice.salePrice;
if (that.minLadderPrice.autoRenewDiscountPrice != null) {
that.skuTotalPrice = that.minLadderPrice.autoRenewDiscountPrice;
} else {

if (that.goodInfo.displayType == 102) {
that.skuTotalPrice = that.getTotalPrice((that.skus0.extPrice + that.skus0.salePrice), that.minLadderPrice
.sendNumber);
} else {
that.skuTotalPrice = that.minLadderPrice.salePrice;
}

}


if (that.goods.isDayStock) {

that.dayStocks = that.goods.dayStocks;
var allnum = 0;
var timeStr = 60 * 60 * 24 * 3 * 1000;
for (var d = 0; d < that.goods.dayStocks.length; d++) {
var tempd = that.goods.dayStocks[d];
if (new Date(tempd.date).valueOf() + timeStr > new Date(that.dtimes[0].date).valueOf()) {
allnum += tempd.stockBalance;
}
}
if (allnum > 0) {
that.manystockBalance = false;
} else {
that.manystockBalance = true;
}
} else if (that.goods.isRepertoryStock) {


var repertoryStocks = that.goods.repertoryStocks;
for (var temp of repertoryStocks) {
if (temp.stockBalance > 0) {
that.manystockBalance = false;
} else {

}
}
} else {

if (that.goods.skus[0].stockBalance == 0) {
that.manystockBalance = true;
}
}


} else {

that.minLadderPrice = res.data.g.goods.skus[0];
that.minLadderPrice['showPrice'] = res.data.g.goods.skus[0].extPrice;
that.minLadderPrice['marketPrice'] = res.data.g.goods.skus[0].salePrice;


if (that.goods.isDayStock) {

var allnum = 0;
var timeStr = 60 * 60 * 24 * 3 * 1000;
for (var d = 0; d < that.goods.dayStocks.length; d++) {
var tempd = that.goods.dayStocks[d];
if (that.dtimes.length > 0) {
if (new Date(tempd.date).valueOf() + timeStr > new Date(that.dtimes[0].date).valueOf()) {
allnum += tempd.stockBalance;
}
}
}
if (allnum > 0) {
that.manystockBalance = false;
} else {}


} else if (that.goods.isRepertoryStock) {
var repertoryStocks = that.goods.repertoryStocks;
for (var temp of repertoryStocks) {
if (temp.stockBalance > 0) {
that.manystockBalance = false;
} else {

}
}
} else {

var manystockBalanceflag = true;
var manystockBalancenum = 0;
for (var t = 0; t < that.goods.skus.length; t++) {
if (that.goods.skus[t].stockBalance == 0) {
manystockBalancenum++;
}
}
if (manystockBalancenum == that.goods.skus.length) {
that.manystockBalance = true;
} else {
that.manystockBalance = false;
}
}

}


if (res.data.g.displayType == 103) {
that.getGroupListFun(); 
}


if (that.goodInfo.discountPromId && that.goodInfo.isAppointment && that.goodInfo.isPreview) {
that.startDate = that.goodInfo.startDate;
}

that.getSingleGoodsActivityFun(res.data); 


let first_utm_source = localStorage.getItem("first_utm_source")
sa.track("BrowseProductDetails", {
platform_type: "H5",
utm_source: that.utm_source,
first_utm_source:first_utm_source,
referrer: document.referrer, // 前向地址
product_id: res.data.g.goods.gid, // 商品编号
product_name: res.data.g.goods.title, // 商品标题
product_subtitle: res.data.g.goods.subtitle, // 商品副标题
product_type: that.cids[res.data.g.goods.cid], // 一级分类
is_cycle: res.data.g.goods.isCycle, // 是否周期

single_goods_activity_id: that.single_goods_activity_id,

single_goods_activity_name: that.single_goods_activity_name,

goods_activity_id: [],

goods_activity_name: [],

activity_type: that.activity_type,
});


if(this.$route.query.uaid){
this.showProductDetail = true
this.BodydiableScroll(true)
}

if(this.$route.query.isFrom){
if(this.goods.status != 4 && this.goods.status != 1 && !this.manystockBalance){
this.showProductDetail = true
this.BodydiableScroll(true)
}

}
}
})
},

getSingleGoodsActivityFun: function(data) {
let activity_type = []; 
let discountList = [],
advanceSale = [],
giftArray = [],
extraArray = [],
groupBuying = [];

if (data.discountList) {
discountList = utils.arrUnique(data.discountList, "pid", "name");
if (data.discountList.length > 0) {
activity_type.push("0");
}
}

if (data.advanceSale) {
advanceSale = [{
aid: data.advanceSale.asId,
name: data.advanceSale.name
}];
activity_type.push("4");
}

if (data.giftArray) {
giftArray = utils.arrUnique(data.giftArray, "aid", "name");
if (data.giftArray.length > 0) {
activity_type.push("2");
}
}

if (data.extraArray) {
extraArray = utils.arrUnique(data.extraArray, "aid", "name");
if (data.extraArray.length > 0) {
activity_type.push("3");
}

}

if (data.groupBuying) {
groupBuying = [{
aid: data.groupBuying.id,
name: data.groupBuying.promotionName
}];
activity_type.push("1");
}

let single_goods_activity = [];
single_goods_activity = single_goods_activity.concat(discountList).concat(advanceSale).concat(giftArray).concat(
extraArray).concat(groupBuying);
let single_goods_activity_id = [],
single_goods_activity_name = [];
for (let item in single_goods_activity) {
single_goods_activity_id.push((single_goods_activity[item].aid).toString());
single_goods_activity_name.push(single_goods_activity[item].name);
}
this.single_goods_activity_id = single_goods_activity_id;
this.single_goods_activity_name = single_goods_activity_name;
this.activity_type = activity_type;
},

getSkuMinPrice: function(skuList) {






















let sku = []; 
if (this.weChat == false && (this.isGift != true || this.goodInfo.displayType == 102 || this.goodInfo.displayType ==
103 )) {
for (let i = 0; i < skuList.length; i++) {
if (skuList[i].isAutoRenew) {
if (skuList[i].autoRenewDiscountPrice != null) {
skuList[i].salePrice = (skuList[i].autoRenewDiscountPrice * skuList[i].sendNumber).toFixed(2);
}
}
sku.push(skuList[i]);
}
} else {
sku = skuList;
}



let minIndex = 0;
if (sku[0].unitExtPrice != null) {
for (let s = 0; s < sku.length; s++) {

if (this.goodInfo.displayType == 103) {
sku[s]['showPrice'] = this.getTotalPrice(sku[s].unitGroupBuyingPrice, sku[s].sendNumber);
} else {
if (sku[s].autoRenewDiscountPrice != null) {
sku[s]['showPrice'] = this.getTotalPrice(sku[s].autoRenewDiscountPrice, sku[s].sendNumber);
}else{
sku[s]['showPrice'] = this.getTotalPrice(sku[s].unitExtPrice, sku[s].sendNumber);
}

}

}
let minShowPrice = Math.min.apply(Math, sku.map((item, index) => {
return item.showPrice
}));
minIndex = sku.findIndex(item => {
return item.showPrice == minShowPrice;
})
} else {
let minSendNumber = Math.min.apply(Math, sku.map((item, index) => {
return item.sendNumber
}));
minIndex = sku.findIndex(item => {
return item.sendNumber == minSendNumber;
})
}

console.log(minIndex)
return sku[minIndex];
},

buyNow: function(type, status, gbid, gift) {
console.log("this.goods--------", this.goods)
this.type = type;
let buy_way = "立即订阅";


if (type == 5) {
let that = this;
if (this.goodInfo.isNewUser && this.cIsNew == 1 || !this.goodInfo.isNewUser) {
discountAppointment(this.goodInfo.discountPromId, this.goods.gid).then(res => {
if (res.code == 1) {
that.$vux.toast.text(res.data.info, 'middle');

that.$refs.ChildComponents.getValidateDiscountPromotion();
}
})
} else {
that.$vux.toast.text("仅新用户可参与活动，您已是老用户", 'middle');
}


return;
}


if (gift == 1) {
this.isGift = true;
if (!this.weChat) {
this.showQrCode = true;
return;
}
} else {
this.isGift = false;
this.showQrCode = false;
}


if (type == 3) {
this.headPrice = true;
buy_way = "开团";
} else {
this.headPrice = false;
buy_way = "单买";
}



if (type == 30) {
buy_way = "去拼团";
this.jionGroup = true;
this.headPrice = false;
this.goodInfo.gbid = gbid;

let uid = getCookie("hdu");
let hdt = getCookie("hdt");
let that = this;
if (!!!uid || !!!hdt) {
chkLogin();
return;
}

}


this.showProductDetail = true;
this.BodydiableScroll(true); 
if (this.goodInfo.displayType == 103) {
this.type = type;
}
if (status == "addCart") {
this.cartFlag = 1;
}else{
this.cartFlag = 0;
}


let first_utm_source = localStorage.getItem("first_utm_source")
sa.track("BuyNow", {
platform_type: "H5",
utm_source: this.utm_source,
first_utm_source:first_utm_source,
referrer: document.referrer, // 前向地址
product_id: this.goods.gid, // 商品编号
product_name: this.goods.title, // 商品标题
product_subtitle: this.goods.subtitle, // 商品副标题
product_price: this.skuTotalPrice,
product_quantity: 1, //商品数量
product_type: this.cids[this.goods.cid], // 一级分类
buy_way: buy_way, //购买方式
is_cycle: this.goods.isCycle, // 是否周期

single_goods_activity_id: this.single_goods_activity_id,

single_goods_activity_name: this.single_goods_activity_name,

goods_activity_id: [],

goods_activity_name: [],

activity_type: this.activity_type,
});


},

closeQrCodeFun: function() {
this.showQrCode = false;
},

closeProductDetail: function() {
this.showProductDetail = false;
this.BodydiableScroll(false); 
},


getViewCartShopNumFun: function() {
this.showProductDetail = false;
this.BodydiableScroll(false); 
let uid = getCookie("hdu");
let hdt = getCookie("hdt");
let that = this;
if (!!!uid || !!!hdt) {
console.info("未登录状态,不查询购物车数量");
} else {





that.$refs.ChildComponents.getViewCartShopNumFun();
}
},

getNotifyByPageTypeFun() {
let that = this;
getNotifyByPageType().then(res => {
if (res.status == 1 && res.result != null) {
that.tipImgSrc = res.result.picUrl;
that.showPulicNotice = true;
that.redirectUrl = res.result.redirectUrl;
}
})
},

gotoPulicNoticeFun: function() {








sa.track("addWechatClick", {
platform_type: "H5",
belong_page: location.href,
type_name:"商品详情底部导航",
type_url:"https://mp.weixin.qq.com/s/di2dWmlxe-KeQE5rGPPvkA"
});
window.location.href = encodeURI("https://mp.weixin.qq.com/s/di2dWmlxe-KeQE5rGPPvkA");
this.showPulicNotice = false;
},

closePulicNoticeFun: function() {







this.showBottomWeChat = false;
},


submitNextFun: function() {
console.log("111111111111111111111111111")
let that = this;

var extraGoods = [];
for (let i = 0; i < this.extraList.length; i++) {
if (this.extraList[i].check) {
extraGoods.push({
"pid": this.extraList[i].aid,
"skuId": this.extraList[i].skuId
});
}
}

if (this.cartFlag == 1) {
let tempArr = [];
let transArr = [];
for (let i = 0; i < extraGoods.length; i++) {
if (tempArr.indexOf(extraGoods[i].pid) === -1) {
transArr.push({
pid: extraGoods[i].pid,
skus: [extraGoods[i].skuId],
type: 1
});
tempArr.push(extraGoods[i].pid);
} else {
for (let j = 0; j < transArr.length; j++) {
if (transArr[j].pid == extraGoods[i].pid) {
transArr[j].skus.push(extraGoods[i].skuId);
break;
}
}
}
}

var params = {
"spuId": 0,
"skuId": this.s_skuId,
"periodsNum": this.s_sendNumber,
"utmFrom": "",
"interval": this.goodInfo.defultDeliveryPeriod,
"receiveDate": this.s_getFlowerDate,
"promotions": transArr,
};

addCart(params).then(res => {
if (res.code == 1) {
that.showProductDetail = false;
that.BodydiableScroll(false); 
that.$vux.toast.text('加入购物车成功', 'middle');
that.getViewCartShopNumFun(); 
}
})
} else {



var giftGoods = [];
for (let i = 0; i < this.giftList.length; i++) {
giftGoods.push({
"pid": this.giftList[i].aid,
"skuId": this.giftList[i].skuId
});
}


let skuId = this.s_skuId; 
let skuLadderPriceId = this.s_skuLadderPriceId; 
let sendNumber = this.s_sendNumber; 
let getDateType = this.goods.getDateType;
let getFlowerDate = this.s_getFlowerDate; 
let deliveryPeriod = this.goodInfo.defultDeliveryPeriod; 
let closeTime = this.goods.closeTime;
let type = this.type;
let isMsg = this.type == 1 ? 1 : 0;
let isAuto = this.isAuto; 
let number = this.s_number;
let aid = "";
let gdt_vid = "";
let discountGoods = [{
pid: this.goodInfo.discountPromId,
skuId: this.s_skuId
}]; //折扣商品




let url = process.env.API + "/order/newOrder"; 
let str = "?gid=" + this.goods.pageUri +
"&extraGoods=" + JSON.stringify(extraGoods) +
"&giftGoods=" + JSON.stringify(giftGoods) +
"&discountGoods=" + JSON.stringify(discountGoods) +
"&skuId=" + skuId +
"&skuLadderPriceId=" + skuLadderPriceId +
"&number=" + number +
"&getDateType=" + getDateType +
"&getFlowerDate=" + getFlowerDate +
"&deliveryPeriod=" + deliveryPeriod +
"&closeTime=" + closeTime +
"&isMsg=" + isMsg +
"&isAuto=" + isAuto +
"&type=" + type +
"&sendNumber=" + sendNumber +
"&aid=" + aid +
"&gdt_vid=" + gdt_vid;


if (this.goodInfo.displayType == 103) {
str += "&gbpId=" + this.gbpId
}


console.log(url + str)


}




},

getRecommendGoodsListFun: function() {
let that = this;
getRecommendGoodsList().then(res => {
if (res.status == 1) {

that.recommendGoodsList = res.result;
}
})
},

getQueryString: function(name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
var r = window.location.search.substr(1).match(reg);

if (r != null) {
return unescape(r[2]);
}
return null;
},

gotoGoodInfoFun: function(goodsCode) {





this.utm_source = "cnxh";


sa.track("PicturenoticeClick", {
belong_page: window.location.href,
page_name: "商品详情",
click_type: 1
});

this.getGoodDetailFun(goodsCode); 
this.getViewCartShopNumFun(); 
this.getNotifyByPageTypeFun(); 
this.getRecommendGoodsListFun(); 
},

gotoCart: function() {
var checkLogin = this.checkLogin();
if (checkLogin == 1) {
window.location.href = mDomain + "/shoppingCart";
} else {
window.location.href = checkLogin;
}
},

checkIsNewFun: function() {
let that = this;
checkIsNew().then(res => {
if (res.status == 1) {
if (res.result.isNew == undefined) {
that.cIsNew = 1;
} else {
that.cIsNew = res.result.isNew;
}
}
})
},

getCurrentEnvironment() {

let ua = navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == "micromessenger") {
this.weChat = true;
} else {
this.weChat = false;
}
},

openProductImg: function(imgUrl) {
this.showProductImg = true; 
this.detailImgSrc = imgUrl; 
},


closeProductImg: function() {
this.showProductImg = false; 
},


getGroupListFun: function() {
let that = this;
let parameter = "?gid=" + this.gid + "&pageNo=1&pageSize=5";
getGroupList(parameter).then(res => {
if (res.code == 1) {
for (var i = 0; i < res.data.records.length; i++) {
res.data.records[i].times = '';
res.data.records[i].iv = 0;
}
console.log("res-------", res)
that.groupList = res.data.records;

that.other(that.groupList);
}
})
},

other: function(groupList) {
var _this = this;

for (var i = 0; i < groupList.length; i++) {

(function(a, that) {

if (that.groupList[a].iv == 0) {

var interval = setInterval(function() {
var second = (that.groupList[a].endTime - Date.parse(new Date())) / 1000;
if (second >= 0) {

var hr = Math.floor(second / 3600);
var hrStr = hr.toString();
if (hrStr.length == 1) hrStr = '0' + hrStr;


var min = Math.floor((second - hr * 3600) / 60);
var minStr = min.toString();
if (minStr.length == 1) minStr = '0' + minStr;


var sec = Math.floor(second - hr * 3600 - min * 60);
var secStr = sec.toString();
if (secStr.length == 1) secStr = '0' + secStr;
var obj = that.groupList;
obj[a].times = hrStr + ':' + minStr + ":" + secStr;

that.groupList = obj;
} else {
clearInterval(interval);
var obj = that.data.list;
obj[a].times = "00:00:00";
that.groupList = obj;
}

}, 100);
}

var obj = that.groupList;
obj[i].iv = interval;
that.groupList = obj;
})(i, _this)
}

},


shareFun: function(pageUri) {

this.showShare = true;



let shareUrl = process.env.SALEURL + "/groupBuying/sdetail?gbId=" + pageUri;

let shareImg = this.imgDomian + '/' + this.headerImgs[0].imgUrl + '?imageView2/2/w/750/h/750/q/75'
let params = {
gbId: pageUri,
shareUrl: window.location.href
}

let that = this;



wechatShare(params).then(res => {
console.log("res-------", res)
if (res.status == 1) {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.result.appId, // 必填，公众号的唯一标识
timestamp: res.result.timestamp, // 必填，生成签名的时间戳
nonceStr: res.result.nonceStr, // 必填，生成签名的随机串
signature: res.result.signature, // 必填，签名，见附录1



jsApiList: ['updateAppMessageShareData', "updateTimelineShareData"]

});

that.shareSetFun(shareUrl, shareImg);


wx.ready(function() {

wx.hideAllNonBaseMenuItem();

});
}
})

},


shareSetFun: function(shareUrl, shareImg, timestamp) {
let that = this;
wx.showMenuItems({
menuList: ["menuItem:share:appMessage", "menuItem:share:timeline"] 
});
wx.updateAppMessageShareData({
title: '邀请你一起来拼团！抢购限量超低价"' + that.goods.title + '"', // 分享标题
desc: that.goods.subtitle, // 分享描述
link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
imgUrl: shareImg, // 分享图标
type: 'link', // 分享类型,music、video或link，不填默认为link
dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
success: function() {



},
fail: function(err) {

},
cancel: function() {

}
});

wx.updateTimelineShareData({
title: '邀请你一起来拼团！抢购限量超低价"' + that.goods.title + '"', // 分享标题
link: shareUrl + "&t=" + timestamp, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
imgUrl: shareImg, // 分享图标
success: function() {




},
cancel: function() {

}
});

},


BodydiableScroll: function(isState) {
var bodyNode = document.body
if (isState) {
this.topSpace = window.scrollY
bodyNode.style.position = 'fixed'
bodyNode.style.top = -this.topSpace + 'px'
} else {
bodyNode.style.position = ''
bodyNode.style.top = ''
window.scrollTo(0, this.topSpace) 
}
},

closeGiftLayer(){
this.giftGoodsImg = ""
},



findEnterpriseWeChatFun:function(){
let hdu = getCookie("hdu");
let hdt = getCookie("hdt");
let that = this;
if (!!!hdu || !!!hdt) {
chkLogin();
return;
}
findEnterpriseWeChat(hdu).then((res) => {
if(res.code == 200){
if(res.data){
that.showWeChat = false;

}else{
that.showWeChat = true;

}
}
});
},


floatBtnClickedFun:function(){
sa.track("addWechatClick", {
platform_type: "H5",
belong_page: location.href,
type_name:"商品详情浮标",
type_url:"https://work.weixin.qq.com/ca/cawcde14dc2b910cd1"
});
window.location.href = "https://work.weixin.qq.com/ca/cawcde14dc2b910cd1"

},

muteFun:function(muted){
this.muted = muted;
},


handleEnd:function(){
let autoplay = {
delay: 3000,
disableOnInteraction: false,
}

this.newSwiper.autoplay.run()
this.showPlayBtn = true;
this.controls = false;
},


playFun:function(){
console.log(this.newSwiper,'newSwiper')
this.$nextTick(()=>{
this.newSwiper.autoplay.pause()

})
this.controls = true;
this.showPlayBtn = false;
var video = document.getElementById("myVideo");
video.play(); 
},


canplayFun:function(){



},


timeupdateFun:function(){



},


judgeClient() {
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

if(isAndroid){
return 'Android';
}else if(isIOS){
return 'IOS';
}else{
return 'PC';
}













},

bannerFun:function(url){

if(url.indexOf("shoppingGold") >= 0){
let utm_source = "";
if(url.indexOf("?utm_source") >= 0){
let sourceArr = url.split("?utm_source=");
if(sourceArr.length > 1){
utm_source = sourceArr[1];
}
}else{
utm_source = this.utm_source;
}
window.location.href =
process.env.PAGEURL +
"/shoppingGold?utm_source=" +
utm_source;
} else{
window.location.href = url;
}

sa.track("detailsBanner_click", {
url: url
});
},

getRateList(gid){
let params = {
gid: gid
}
rateList(params).then(res=>{
if(res.data.length>0){
let arr = [];
for(let i=0; i< 1; i++){
arr.push(res.data[i])
}

this.rateItemList = arr.map(item=>{
if(item.picUrls){
item.imgsList = item.picUrls.split(',')
item.imgsList = item.imgsList.slice(0, 2)
}
return item
})

}

})
},

lookMoreRate(){
this.$router.push({
path: '/rateList',
query:{
gid: this.gid
}
})
},




},
filters: {

}
};



// WEBPACK FOOTER //
// ./src/view/goodDetails/goodDetails.vue